export const navTypes = {
  MENU_SLIDE: 'MENU_SLIDE',
};
